import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d89ba6a8")

_pushScopeId("data-v-d89ba6a8")
const _hoisted_1 = {
  class: "all-tickets",
  id: "all-tickets"
}
const _hoisted_2 = { class: "operations" }
const _hoisted_3 = { class: "ticket-title" }
const _hoisted_4 = {
  key: 0,
  class: "i-task"
}
const _hoisted_5 = {
  key: 1,
  class: "i-working"
}
const _hoisted_6 = {
  key: 2,
  class: "i-aftersale"
}
const _hoisted_7 = {
  key: 3,
  class: "i-test"
}
const _hoisted_8 = {
  key: 0,
  class: "warning"
}
const _hoisted_9 = {
  key: 1,
  class: "timeout"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "operation-btn-wrap" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("认领")
const _hoisted_14 = {
  key: 0,
  class: "pagination-wrap"
}
const _hoisted_15 = { class: "phase-select-dialog" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "title" }, "请选择工作流节点", -1)
const _hoisted_17 = { class: "content" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "label" }, "处理节点：", -1)
const _hoisted_19 = { class: "button-area" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TicketViewSearchForm = _resolveComponent("TicketViewSearchForm")
  const _component_ExportTickets = _resolveComponent("ExportTickets")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_TicketViewSearchForm, {
        keywords: _ctx.keywords,
        "onUpdate:keywords": _cache[1] || (_cache[1] = ($event: any) => (_ctx.keywords = $event)),
        queryForm: _ctx.savedQueryData,
        submit: _ctx.ticketViewSearchFormSubmit,
        useStatus: true,
        ref: "viewSearchForm"
      }, null, 8, ["keywords", "queryForm", "submit"]),
      _createVNode(_component_ExportTickets, {
        keywords: _ctx.keywords,
        action: _ctx.exportTicketList,
        total: _ctx.total
      }, null, 8, ["keywords", "action", "total"])
    ]),
    _withDirectives(_createVNode(_component_el_table, {
      border: "",
      class: "ticket-table",
      data: _ctx.tableData,
      style: {"width":"100%"},
      "default-sort": _ctx.orderField,
      onSortChange: _ctx.sortChange
    }, {
      default: _withId(() => [
        _createVNode(_component_el_table_column, {
          prop: "id",
          width: "80",
          sortable: "custom",
          label: "编号"
        }, {
          default: _withId((scope) => [
            _createVNode("div", {
              onClick: ($event: any) => (_ctx.goBlankRouter(scope))
            }, _toDisplayString(scope.row.id), 9, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "title",
          label: "标题",
          "show-overflow-tooltip": "",
          width: "180"
        }, {
          default: _withId((scope) => [
            _createVNode("div", _hoisted_3, [
              _createVNode("span", {
                onClick: ($event: any) => (_ctx.goBlankRouter(scope)),
                class: "title"
              }, [
                (scope.row.sourceType === 'task')
                  ? (_openBlock(), _createBlock("i", _hoisted_4))
                  : _createCommentVNode("", true),
                (scope.row.sourceType === 'warning')
                  ? (_openBlock(), _createBlock("i", _hoisted_5))
                  : _createCommentVNode("", true),
                (scope.row.sourceType === 'after_sale')
                  ? (_openBlock(), _createBlock("i", _hoisted_6))
                  : _createCommentVNode("", true),
                (scope.row.sourceType === 'test')
                  ? (_openBlock(), _createBlock("i", _hoisted_7))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(scope.row.title), 1)
              ], 8, ["onClick"]),
              (scope.row.warning)
                ? (_openBlock(), _createBlock("span", _hoisted_8, "超时预警"))
                : _createCommentVNode("", true),
              (scope.row.timeout)
                ? (_openBlock(), _createBlock("span", _hoisted_9, "已超时"))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "desc",
          label: "描述"
        }, {
          default: _withId((scope) => [
            (scope.row.desc)
              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                  key: 0,
                  placement: "top"
                }, {
                  content: _withId(() => [
                    _createVNode("div", {
                      innerHTML: scope.row.desc
                    }, null, 8, ["innerHTML"])
                  ]),
                  default: _withId(() => [
                    _createVNode("div", {
                      class: "ticket-desc",
                      innerHTML: scope.row.desc
                    }, null, 8, ["innerHTML"])
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "curPhase",
          width: "90",
          label: "阶段",
          sortable: "custom"
        }, {
          default: _withId(({ row }) => [
            (row.curPhaseId)
              ? (_openBlock(), _createBlock("span", _hoisted_10, _toDisplayString(row.curPhase), 1))
              : (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList((row.curPhases?.map(v => v.phaseName) || []), (v, index) => {
                  return (_openBlock(), _createBlock("div", { key: index }, _toDisplayString(v), 1))
                }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "urgentLevel",
          width: "110",
          label: "紧急程度",
          sortable: "custom",
          formatter: _ctx.priorityFormatter
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          prop: "curStatus",
          width: "100",
          label: "状态",
          sortable: "custom",
          formatter: _ctx.curStatusFormatter
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          prop: "createdAt",
          label: "创建时间",
          sortable: "custom",
          width: "120",
          formatter: _ctx.createTimeFormatter
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          prop: "responsibleAgentName",
          width: "150",
          label: "处理人"
        }, {
          default: _withId(({ row }) => [
            (row.curPhaseId)
              ? (_openBlock(), _createBlock("span", _hoisted_11, _toDisplayString(row.responsibleAgentName || '-'), 1))
              : (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList((row.curPhases?.map(v => v.responsibleAgentName || '-') || []), (v, index) => {
                  return (_openBlock(), _createBlock("div", { key: index }, _toDisplayString(v), 1))
                }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "operation",
          width: "90",
          label: "操作"
        }, {
          default: _withId((scope) => [
            _createVNode("div", _hoisted_12, [
              (_ctx.canHandle(scope.row))
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    class: "operation-btn",
                    type: "text",
                    onClick: ($event: any) => (_ctx.assignMe(scope.row)),
                    "data-track-click": JSON.stringify({
                 category: '工单视图-认领',
                 action: '点击',
               })
                  }, {
                    default: _withId(() => [
                      _hoisted_13
                    ]),
                    _: 2
                  }, 1032, ["onClick", "data-track-click"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "default-sort", "onSortChange"]), [
      [_directive_loading, _ctx.loading]
    ]),
    (_ctx.total)
      ? (_openBlock(), _createBlock("div", _hoisted_14, [
          _createVNode(_component_el_pagination, {
            onSizeChange: _ctx.handleSizeChange,
            onCurrentChange: _ctx.handleCurrentChange,
            "current-page": _ctx.currentPage,
            "page-sizes": [10, 20, 50, 100],
            "page-size": _ctx.pageSize,
            layout: "prev, pager, next, sizes, jumper, total",
            total: _ctx.total
          }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_15, [
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.showPhaseSelectDialog,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.showPhaseSelectDialog = $event)),
        width: "364px"
      }, {
        default: _withId(() => [
          _hoisted_16,
          _createVNode("div", _hoisted_17, [
            _hoisted_18,
            _createVNode(_component_el_select, {
              modelValue: _ctx.selectedPhase,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedPhase = $event))
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.phaseList, (phase) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: phase.phaseId,
                    value: phase.phaseId,
                    label: phase.phaseName
                  }, null, 8, ["value", "label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createVNode("div", _hoisted_19, [
            _createVNode("div", {
              class: "cancel-button",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showPhaseSelectDialog = false))
            }, "取 消"),
            _createVNode("div", {
              class: "confirm-button",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.assignWithPhase && _ctx.assignWithPhase(...args)))
            }, "确 定")
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
})